import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

export const usePendingApprovals = () => {
    const [pendingCount, setPendingCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Query for users with approved === false
        const q = query(
            collection(db, 'users'),
            where('approved', '==', false)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setPendingCount(snapshot.size);
            setLoading(false);
        }, (error) => {
            console.error('Error fetching pending approvals:', error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return { pendingCount, loading };
};
